define('ItemBadges.ProductList', [
    'ItemBadges.Collection',
    'ItemBadges.View'
], function ItemBadgesProductList(
    ItemBadgesCollection,
    ItemBadgesView
) {
    'use strict';

    var plp;
    var itemBadgesCollection;
    var itemBadgesProductList = {
        loadProductListItemBadges: function loadPDPItemBadges(application) {
            plp = application.getComponent('PLP');

            itemBadgesProductList.loadProductListEvents();
            itemBadgesProductList.addProductListChildViews();
        },

        loadProductListEvents: function loadEventsPDP() {
            plp.on('beforeShowContent', function beforeShowContent() {
                if (!itemBadgesCollection) {
                    itemBadgesCollection = new ItemBadgesCollection();
                }
            });

            plp.on('afterShowContent', function afterShowContent() {
                if (itemBadgesCollection.length === 0) {
                    itemBadgesCollection.fetch();
                }
            });
        },

        addProductListChildViews: function addPDPChildViews() {
            plp.addChildViews(
                plp.PLP_VIEW, {
                    'ItemDetails.Options': {
                        'Itembadges.View': {
                            childViewIndex: 5,
                            childViewConstructor: function childViewConstructor() {
                                return new ItemBadgesView({
                                    collection: itemBadgesCollection
                                });
                            }
                        }
                    }
                }
            );
        }
    };

    return itemBadgesProductList;
});
